/*
 * Bridges external add-to-cart actions (e.g. Replo) to the theme cart drawer.
 * The theme's own product forms already open/refresh the drawer; page builders
 * that POST to /cart/add.js do not. This watches every /cart/add request and,
 * only when nothing else has opened the drawer, refreshes its contents from the
 * Section Rendering API and opens it.
 */
(function () {
  if (window.__cartExternalAddBridge) return;
  window.__cartExternalAddBridge = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch;

  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0];
    var promise = origFetch.apply(this, arguments);
    try {
      // Bundle Studio already handles its drawer or direct-checkout navigation.
      // Its background gift repairs must not open a second drawer either.
      var headers = new Headers((arguments[1] && arguments[1].headers) || (arguments[0] && arguments[0].headers));
      var handled = headers.has('X-Enamio-Bundle-Add') || headers.has('X-Enamio-Cart-Guard');
      if (!handled && typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        promise
          .then(function (res) {
            if (res && res.ok) setTimeout(maybeOpenDrawer, 300);
          })
          .catch(function () {});
      }
    } catch (e) {}
    return promise;
  };

  function maybeOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // Already handled by the theme's native flow (e.g. Dawn product form) — leave it.
    if (drawer.classList.contains('active')) return;
    refreshAndOpen(drawer);
  }

  function refreshAndOpen(drawer) {
    origFetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var parsed = parser.parseFromString(sections['cart-drawer'] || '', 'text/html');

        var freshInner = parsed.querySelector('#CartDrawer');
        var liveInner = document.querySelector('#CartDrawer');
        if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;

        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var freshBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }

        // Replacing #CartDrawer drops the overlay's click handler — rebind it.
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }

        if (typeof drawer.syncEmptyState === 'function') drawer.syncEmptyState();
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.classList.add('active');
      })
      .catch(function (e) { console.error('[CartBridge]', e); });
  }
})();
